<template>
  <nav v-if="userUUID" class="navbar  z-index-999" :class="classes">

    <a class="sidebar-toggler cursor-pointer " @click="toggle" :class="isTogglerActive ? 'active' : 'not-active'">
      <font-awesome-icon icon="bars" size="lg" />
    </a>
    <div class="navbar-content">

      <ul class="navbar-nav">

        <li class="nav-item dropdown langs">

          <a class="nav-link dropdown-toggle  " href="javascript:void(0);" id="profileDropdown" role="button"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="alert-numbers lang ">{{ selectedLang }}</span>
          </a>
          <div class="dropdown-menu " aria-labelledby="profileDropdown">
            <ul class="list-unstyled  ">
              <li v-for="(lang, index) in langs" class="dropdown-item d-flex cursor-pointer lang-item"
                :class="{ 'active-lang': selectedLang == lang }" @click="changeLanguage(lang)" v-bind:key="index">
                <span class="symbole-lang"> {{ i18n.t('lang.' + lang + '.symbole') }} </span>
                <span>{{ i18n.t('lang.' + lang + '.title') }} </span>
              </li>


            </ul>
          </div>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle " href="javascript:void(0);" id="profileDropdown" role="button"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img class="wd-30 ht-30 rounded-circle" src="@/assets/img/icons/member.png" alt="profile" />
          </a>
          <div class="dropdown-menu  " aria-labelledby="profileDropdown">
            <div class="d-flex flex-column align-items-center bcustom-alert-bottom px-5 py-1 border-bottom">
              <div class="text-left">
                <p class="tx-16 text-uppercase ">
                  <b>{{ user?.firstName || '' }} {{ user?.lastName || '' }} </b>
                </p>
              </div>
              <div class="text-left">
                <p class="tx-16 "> {{ user?.email || '' }} </p>
              </div>
            </div>


            <ul class="list-unstyled ">
              <li v-if="hasAdminRole()" class="dropdown-item  cursor-pointer border-bottom">
                <router-link :to="{ name: 'clubs', params: { userUUID: userUUID } }"
                  class=" bg-none text-body  py-1 d-block w-100">
                  <font-awesome-icon icon="shop" size="lg" class="me-2 icon-md" />
                  <span> {{ i18n.t('layout.navbar.dropdown.admin_space') }} </span>
                </router-link>
              </li>

              <li class="dropdown-item  cursor-pointer  border-bottom" @click="switchClub()">
                <a class="bg-none text-body  py-1 d-block w-100">
                  <font-awesome-icon icon="repeat" size="lg" class="me-2 icon-md" />
                  <span class="link-title"> {{ i18n.t('layout.navbar.dropdown.switch_club') }} </span>
                </a>
              </li>
              <!-- <li v-if="hasAdminRole()" class="dropdown-item  cursor-pointer border-bottom">
                <router-link :to="{ name: 'create-club', params: { userUUID: userUUID } }"
                  class="bg-none text-body  py-1 d-block w-100">
                  <font-awesome-icon icon="plus" size="lg" class="me-2 icon-md" />
                  <span>{{ i18n.t('layout.navbar.dropdown.create_club') }} </span>
                </router-link>
              </li> -->

              <li class="dropdown-item  cursor-pointer border-bottom">
                <router-link :to="{ name: 'profile', params: { userUUID: userUUID } }"
                  class="bg-none text-body  py-1 d-block w-100">
                  <font-awesome-icon icon="user-tie" size="lg" class="me-2 icon-md" />
                  <span>{{ i18n.t('layout.navbar.dropdown.profile') }} </span>
                </router-link>
              </li>
              <li class="dropdown-item  cursor-pointer border-bottom">
                <router-link :to="{ name: 'support', params: { userUUID: userUUID } }"
                  class=" bg-none text-body  py-1 d-block w-100">
                  <font-awesome-icon icon="headset" size="lg" class="me-2 icon-md" />
                  <span>{{ i18n.t('layout.navbar.dropdown.support') }} </span>
                </router-link>
              </li>
           
              <li class="dropdown-item  cursor-pointer" @click.prevent="logout">
                <a class="bg-none text-body  py-1 d-block w-100">
                  <font-awesome-icon icon="sign-out-alt" size="lg" class="me-2 icon-md" />
                  <span>{{ i18n.t('layout.navbar.dropdown.logout') }} </span>
                </a>
              </li>


            </ul>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script lang="ts">
import Swal from "sweetalert2";
import i18n from "@/i18n/index"
import { defineComponent, ref, computed, toRefs, watch } from 'vue';
import { selectedLang, userUUID, clubUUID, currentClub, user } from '@/shared/state';
import { transactions_due_date, expired_subscriptions, subscriptions_expiring, transactions_due_date_count, expired_subscriptions_count, subscriptions_expiring_count } from '@/shared/state';
import { useGlobal } from "@/composables/global/useGlobal";
import { useLogin } from '@/composables/auth/useLogin';
import { useClub } from '@/composables/club/useClub';
import { useModal } from '@/composables/modal/useModal';
import { useMember } from "@/composables/member/useMember";
import { useUser } from "@/composables/auth/useUser";

import { MemberSearchParams } from "@/interfaces/member";

export default defineComponent({
  props: {
    classes: {
      type: Object,
      default: null,
    }
  },

  name: 'NavBar',
  setup(props) {
    const { classes } = toRefs(props);
    const { formatDate, languages } = useGlobal();
    const langs = languages()
    const transactions_due_dateList = computed(() => transactions_due_date.data);
    const expired_subscriptionsList = computed(() => expired_subscriptions.data);
    const subscriptions_expiringList = computed(() => subscriptions_expiring.data);

    const transactions_due_dateCount = computed(() => transactions_due_date_count);
    const expired_subscriptionsCount = computed(() => expired_subscriptions_count);
    const subscriptions_expiringCount = computed(() => subscriptions_expiring_count);
    const fiche_member: any = ref(null)
    const searchBy = ref<MemberSearchParams>({
      id: null,
      clubUUID: clubUUID.value,
      memberUUID: "",
      matricule: "",
      name: "",
      email: "",
      tele: "",
      cin: "",
      dateBirth: [],
      gender: "",
      contractNumber: "",
      seller_id: null,
      hasSubscriptionActive: "", // true to get all members has subscription active
      type: "first",
      page: 0,
      limit: 0,
      with_subscriptions: "false",
      with_current_subscription: "false",
      with_seller: "false",
      with_transactions: "false",
      appends: []
    });

    const { logout, error } = useLogin();
    const { switchClub } = useClub();
    const { openModal } = useModal();
    const { fetchMemberByCIN } = useMember();
    const { hasAdminRole } = useUser();

    const searchMemberByCIN = () => {
      if (searchBy?.value?.cin?.trim() === '') {
        return;
      }
      fetchMemberByCIN(searchBy.value).then((response) => {

        if (response?.member_info?.id) {
          fiche_member.value = response || null
          openModal('modal_browser', 'add', null)
          searchBy.value.cin = null
        } else {
          Swal.fire({
            title: i18n.t("message.not_found.member_not_found.title"),
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "OK",
            allowOutsideClick: false,   // ✅ disable closing by clicking outside
            allowEscapeKey: false       // (optional) disable closing with ESC
          })
        }
      })
    };

    const changeLanguage = (lang: string) => {
      localStorage.setItem('selectedLang', lang)
      i18n.setLocale(lang)
      selectedLang.value = lang
      if (lang == "ar") {
        localStorage.setItem('style', 'rtl')
        location.reload();
      } else {
        localStorage.setItem('style', 'ltr')
        location.reload();
      }
    };

    const isTogglerActive = ref(false)
    const isSidebarFolded = ref(false)
    const isSidebarOpen = ref(false)

    // Watch for sidebar state changes
    watch([isSidebarFolded, isSidebarOpen], ([folded, opened]) => {
      document.body.classList.toggle('sidebar-folded', folded)
      document.body.classList.toggle('sidebar-open', opened)
    })

    const toggle = () => {
      isTogglerActive.value = !isTogglerActive.value

      if (window.matchMedia("(min-width: 992px)").matches) {
        isSidebarFolded.value = !isSidebarFolded.value
        isSidebarOpen.value = false
      } else {
        isSidebarOpen.value = !isSidebarOpen.value
        isSidebarFolded.value = false
      }
    }



    return {
      isTogglerActive,
      toggle,
      transactions_due_dateCount,
      expired_subscriptionsCount,
      subscriptions_expiringCount,
      transactions_due_dateList,
      expired_subscriptionsList,
      subscriptions_expiringList,
      switchClub,
      logout,
      currentClub,
      userUUID,
      clubUUID,
      error,
      searchMemberByCIN,
      searchBy,
      fiche_member,
      changeLanguage,
      i18n,
      user,
      selectedLang,
      formatDate,
      hasAdminRole,
      langs
    };
  },
});
</script>